var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSampleUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Upload"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.99986 5.03606H7.3195V11.0771C7.3195 11.1557 7.38379 11.22 7.46236 11.22H8.53379C8.61236 11.22 8.67665 11.1557 8.67665 11.0771V5.03606H9.99986C10.1195 5.03606 10.1856 4.89856 10.1124 4.80571L8.11236 2.27356C8.099 2.25649 8.08192 2.24268 8.06243 2.23318C8.04294 2.22369 8.02154 2.21875 7.99986 2.21875C7.97818 2.21875 7.95678 2.22369 7.93729 2.23318C7.9178 2.24268 7.90072 2.25649 7.88736 2.27356L5.88736 4.80392C5.81415 4.89856 5.88022 5.03606 5.99986 5.03606ZM14.5356 10.5414H13.4641C13.3856 10.5414 13.3213 10.6057 13.3213 10.6843V13.4343H2.67843V10.6843C2.67843 10.6057 2.61415 10.5414 2.53557 10.5414H1.46415C1.38557 10.5414 1.32129 10.6057 1.32129 10.6843V14.22C1.32129 14.5361 1.57665 14.7914 1.89272 14.7914H14.107C14.4231 14.7914 14.6784 14.5361 14.6784 14.22V10.6843C14.6784 10.6057 14.6141 10.5414 14.5356 10.5414Z",
    fill: "#2563EB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSampleUpload);
export default __webpack_public_path__ + "static/media/SampleUpload.95c6384e0abf193f975378ff543584be.svg";
export { ForwardRef as ReactComponent };